import React from 'react'

export default function Index() {
    return (
        <p className='mt-5 text-center'>Error retrieving data. Please, try again.</p>
    )
}
